import { Link, Tooltip } from '@material-ui/core';
import React from 'react';
import { STORE_URL } from 'settings';

import * as S from './styles';

function Store() {
  return (
    <Tooltip title='Store' placement='bottom'>
      <Link id='topbar-store-link' target='_blank' href={STORE_URL} rel='noopener noreferrer'>
        <S.IconImg src='/img/icon-store-topbar.svg' alt='Ícone de carrinho para a Loja de Apps Eduzz' />
      </Link>
    </Tooltip>
  );
}

export default Store;
